export default "__VITE_ASSET__CCG3kpNO__"